import React from 'react'
import classNames from 'classnames'
import './styles.less'

type GlyphProps = React.HTMLAttributes<HTMLSpanElement>

// A 1em stroked glyph in the current colour; the paths are icon set 5.5.4's chevron-back and close-outline.
const Glyph: React.FC<GlyphProps & { title: string; children: React.ReactNode }> = ({
	title,
	className,
	children,
	...rest
}) => (
	<span className={classNames('glyph', className)} {...rest}>
		<span className="glyph-inner">
			<svg xmlns="http://www.w3.org/2000/svg" className="glyph-svg" viewBox="0 0 512 512">
				<title>{title}</title>
				{children}
			</svg>
		</span>
	</span>
)

export const ChevronBackGlyph: React.FC<GlyphProps> = props => (
	<Glyph title="Chevron Back" {...props}>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="48"
			d="M328 112L184 256l144 144"
			className="glyph-fill-none"
		/>
	</Glyph>
)

export const CloseGlyph: React.FC<GlyphProps> = props => (
	<Glyph title="Close" {...props}>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M368 368L144 144M368 144L144 368"
			className="glyph-fill-none glyph-stroke-width"
		/>
	</Glyph>
)
